import { SVGProps, Ref, forwardRef } from 'react';

export const LockOpenedFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.586 4.666c-.104-.831-.312-1.56-.619-2.112-.415-.748-.982-1.154-1.9-1.154s-1.485.406-1.9 1.154c-.262.47-.45 1.067-.566 1.747 2.028.55 2.396 2.018 2.396 5.697 0 5.248-.75 5.998-5.998 5.998-5.25 0-5.999-.75-5.999-5.998 0-5.25.75-5.999 5.999-5.999.854 0 1.589.02 2.22.076C8.598 1.838 9.72 0 12.068 0c2.552 0 3.656 2.17 3.929 4.666zM6.7 11.664V8.33h-1.4v3.333z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
LockOpenedFilledSize16Glyph.displayName = 'LockOpenedFilledSize16Glyph';
